import { api } from "@/api";

export type BalanceOperation = "add" | "remove";

interface UpdateDealerBalancePayload {
  userIds: number[];
  operation: BalanceOperation;
  amount: number;
}

export async function updateDealerBalance(
  payload: UpdateDealerBalancePayload
): Promise<{ success: boolean }> {
  await Promise.all(
    payload.userIds.map((dealerId) =>
      api.client.patch(`/dealers-new/${dealerId}/balance`, {
        operation: payload.operation,
        amount: payload.amount,
      })
    )
  );
  return { success: true };
}
